import { Image } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const OrderConfirmed = styled.div`
  display: flex;
  flex-grow: 1;
  gap: 1.6rem;
  justify-content: space-between;
`;

const OrderBody = styled.div`
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  height: fit-content;
  padding: 1.6rem;
  width: 50%;
`;

const OrderBodyHeader = styled.section`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

const OrderBodyContent = styled.section`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

const OrderBodyFooter = styled.section``;

const OrderBodyFooterText = styled.p`
  color: var(--color-fg-weaker);
  margin-bottom: 2.4rem;
`;

const OrderBodyFooterActions = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
`;

const OrderBodyRow = styled.div`
  align-items: flex-start;
  display: flex;
  gap: 16px;
  justify-content: space-between;
`;

const OrderConfirmedMessage = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0 auto;
  max-width: 488px;
  text-align: center;

  ${Image.S.Image} {
    margin-bottom: 36px;
  }
`;

const SupportLink = styled.a`
  color: var(--color-fg-default) !important;
  text-decoration: underline;
`;

export {
  OrderBody,
  OrderBodyContent,
  OrderBodyFooter,
  OrderBodyFooterActions,
  OrderBodyFooterText,
  OrderBodyHeader,
  OrderBodyRow,
  OrderConfirmed,
  OrderConfirmedMessage,
  SupportLink
};
